export const botBuilderTabs = {
    BASIC_COMPONENT: 1,
    INTEGRATION_COMPONENT: 2,
    SECURITY_COMPONENT: 3
}